<template>
  <div class="dialog search-result">
    <div class="dialog-content">
      <div>
        <div class="table" v-if="step == 1">
          <div class="table-header">
            <div class="title">{{ ts('Stay-Extend')['Stay-Extend'] }}</div>
          </div>
          <div class="table-content">
            <div class="stay-form">
              <div class="tips">{{ ts('Enter the number of night you would like to extend')['Enter the number of night you would like to extend'] }}</div>
              <div class="stay-number"><el-input v-model="stayDays"></el-input>{{ ts('night')['night'] }}</div>
              <div class="tips">{{ ts('Choose the number of guest')['Choose the number of guest'] }}</div>
              <div class="guest-number"><el-input-number v-model="guestNumber" :min="1" step-strictly></el-input-number></div>
            </div>
          </div>
        </div>
        <div class="table" v-if="step == 2">
          <div class="table-header">
            <div class="title">{{ ts('Accommondation Fee')['Accommondation Fee'] }}</div>
          </div>
          <div class="table-content">
            <div class="sub-title">{{ ts('Date')['Date'] }} : {{ tableData[0].startDate }}~{{ tableData[0].endDate }} ({{ stayDays }} {{ ts('Nights')['Nights'] }})</div>
            <el-table :data="tableData" :border="false" style="width: 100%" v-if="tableData.length > 0">
              <el-table-column :label="ts('Room Type')['Room Type']" prop="roomTypeId_dictText" align="center"></el-table-column>
              <el-table-column :label="ts('Room No.')['Room No.']" prop="roomNo" align="center"></el-table-column>
              <el-table-column :label="ts('Guest')['Guest']" align="center">
                <template slot-scope="scope">
                  <el-input-number disabled v-model="guestNumber" size="small" :min="1" step-strictly></el-input-number>
                </template>
              </el-table-column>
              <el-table-column :label="ts('Amount')['Amount']" align="center">
                <template slot-scope="scope">
                  {{ `${currency} ${scope.row.roomPrice}` }}
                </template>
              </el-table-column>
            </el-table>
            <ul class="price-list">
              <li>
                <span class="label">{{ ts('Sub-total')['Sub-total'] }} :</span>
                <span class="value">{{ currency }} {{ tableData[0].roomPrice }}</span>
              </li>
              <li>
                <span class="label">{{ ts('Tax Total')['Tax Total'] }} :</span>
                <span class="value">{{ currency }} {{ tableData[0].totalTax }}</span>
              </li>
              <li>
                <span class="label">{{ ts('Other Fee Total')['Other Fee Total'] }} :</span>
                <span class="value">{{ currency }} {{ tableData[0].totalFee }}</span>
              </li>
              <li>
                <span class="label">{{ ts('Accommondation Fee Total')['Accommondation Fee Total'] }} :</span>
                <span class="value">{{ currency }} {{ tableData[0].total }}</span>
              </li>
            </ul>
            <div class="tips" style="margin: 20px 0; color: #c1272d; text-align: center">
              {{ ts('We are not able to extand your stay with the same room, another room will be assigned.')['We are not able to extand your stay with the same room, another room will be assigned.'] }}
              <br />
              {{ ts('Would you like to continue?')['Would you like to continue?'] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="result-footer pay" @click="selectPayMethod" v-if="step == 2">{{ ts('PAY NOW')['PAY NOW'] }}</div>
    <div class="result-footer" v-if="step == 1">
      <div class="back"></div>
      <div class="next" @click="handleNext">{{ ts('NEXT')['NEXT'] }}</div>
    </div>
    <!-- 支付方式 -->
    <el-dialog :visible.sync="payMethodVisible" :append-to-body="true" width="1000px">
      <PayMethod orderType="RENEW_ORDER" :orderId="orderId" @confirm="createPayment" />
    </el-dialog>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import { LanguagePackage } from '@/mixins/LanguagePackage'
import PayMethod from '@/components/PayMethod.vue'

export default {
  name: 'StayExtend',
  props: ['order'],
  mixins: [LanguagePackage],
  components: {
    PayMethod,
  },
  data() {
    return {
      stayDays: '',
      guestNumber: 1,
      tableData: [],
      currency: '',
      step: 1,
      payMethodVisible: false,
      orderId: null,
    }
  },
  created() {},
  methods: {
    handleNext() {
      if (this.stayDays == '') {
        return this.$message.error(this.translate('Enter the number of night you would like to extend'))
      }
      const loading = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      postAction(`/user/api/extendStay`, {
        days: this.stayDays,
        orderId: this.order.id,
        person: this.guestNumber,
      })
        .then((res) => {
          this.currency = res.result.currency
          this.orderId = res.result.id
          this.tableData = [res.result]
          this.step = 2
          loading.close()
        })
        .catch(() => {
          loading.close()
        })
    },
    selectPayMethod() {
      this.payMethodVisible = true
    },
    // 创建续房支付
    createPayment(platForm) {
      this.$store.dispatch('createExtendStayPayment', {
        orderId: this.orderId,
        platForm, // Stripe , Paypay
      })
    },
  },
}
</script>

<style scoped lang="scss"></style>
